var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var EquipmentCostAPI = /** @class */ (function (_super) {
    __extends(EquipmentCostAPI, _super);
    function EquipmentCostAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EquipmentCostAPI.prototype.list = function (props) { return this.fetchPaginated("/api/costing/equipment/list", props); };
    EquipmentCostAPI.prototype.create = function (props) { return this.fetcher.post("/api/costing/equipment/create", props); };
    EquipmentCostAPI.prototype.update = function (props) { return this.fetcher.post("/api/costing/equipment/update", props); };
    EquipmentCostAPI.prototype.remove = function (props) { return this.fetcher.post("/api/costing/equipment/remove", props); };
    return EquipmentCostAPI;
}(SubAPI));
export { EquipmentCostAPI };
